var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.value))]
        ),
        _vm.revertLink && Object.keys(_vm.revertLink).length
          ? _c("div", { staticClass: "mb bottom align-right" }, [
              _c(
                "a",
                {
                  class: { "is-loading": _vm.isRevertLoading },
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.revertCommonTemplate($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.revertLink.title) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _c("textarea", {
          staticClass: "width100 textarea-ace-editor",
          attrs: { id: "textarea-editor-" + _vm.id },
          domProps: { value: _vm.dataList.template },
          on: { input: _vm.onInput }
        }),
        _c("div", { attrs: { id: "js-redactor-block-" + _vm.id } })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }